import React, { useEffect, useState } from "react";
import { Box, Button, Paper, Typography } from "@mui/material";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import { Link } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { useDispatch, useSelector } from "react-redux";
import { jobLoadAction } from "../../redux/actions/jobAction";
import CreateJob from "../CreateJobs";
import { BiArrowBack } from "react-icons/bi";
import axios from "axios";
import { toast } from "react-toastify";

const DashJobs = () => {
  const dispatch = useDispatch();
  const [create, setCreate] = useState(true);
  useEffect(() => {
    dispatch(jobLoadAction());
  }, []);

  const { jobs, loading } = useSelector((state) => state.loadJobs);
  const { userInfo } = useSelector((state) => state.signIn);
  console.log(userInfo);
  let data = [];
  data = jobs !== undefined && jobs.length > 0 ? jobs : [];
  console.log(data);

  //delete job by Id
  const deleteJobById = async (e, id) => {
    try {
      const config = {
        headers: { Authorization: "Bearer " + userInfo.token },
      };
      await axios.delete(`/api/jobs/${id}`, config);
      dispatch(jobLoadAction());
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };

  const columns = [
    {
      field: "_id",
      headerName: "Job ID",
      width: 150,
      editable: true,
    },
    {
      field: "jobPosition",
      headerName: "Position",
      width: 150,
      valueGetter: (data) => data.row.position,
    },
    {
      field: "jobType",
      headerName: "jobType",
      width: 150,
      valueGetter: (data) => data.row.jobType,
    },
    {
      field: "Company",
      headerName: "Company",
      width: 150,
      valueGetter: (data) => data.row.company.name,
    },
    {
      field: "available",
      headerName: "available",
      width: 150,
      renderCell: (values) => "yes",
    },

    {
      field: "minsalary",
      headerName: "minSalary",
      type: Number,
      width: 150,
      renderCell: (values) => values.row.minSalary + "$",
    },
    {
      field: "maxsalary",
      headerName: "maxSalary",
      type: Number,
      width: 150,
      renderCell: (values) => values.row.maxSalary + "$",
    },

    {
      field: "Actions",
      width: 200,
      renderCell: (values) => (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "170px",
          }}
        >
          <Button
            onClick={(e) => deleteJobById(e, values.row._id)}
            variant="contained"
            color="error"
          >
            Delete
          </Button>
        </Box>
      ),
    },
  ];

  return (
    <Box>
      <Typography variant="h4" sx={{ color: "white", pb: 3 }}>
        Jobs list
      </Typography>
      {create ? (
        <>
          <Box sx={{ pb: 2, display: "flex", justifyContent: "right" }}>
            <Button
              onClick={() => setCreate(!create)}
              variant="contained"
              color="success"
              startIcon={<AddIcon />}
            >
              {" "}
              Create Job
            </Button>
          </Box>
          <Paper sx={{ bgcolor: "secondary.midNightBlue" }}>
            <Box sx={{ height: 400, width: "100%" }}>
              <DataGrid
                getRowId={(row) => row._id}
                sx={{
                  "& .MuiTablePagination-displayedRows": {
                    color: "white",
                  },
                  color: "white",
                  [`& .${gridClasses.row}`]: {
                    bgcolor: (theme) =>
                      // theme.palette.mode === 'light' ? grey[200] : grey[900],
                      theme.palette.secondary.main,
                  },
                  button: {
                    color: "#ffffff",
                  },
                }}
                rows={data}
                columns={columns}
                pageSize={5}
                rowsPerPageOptions={[5]}
              />
            </Box>
          </Paper>
        </>
      ) : (
        <>
          <CreateJob />
          <BiArrowBack
            style={{
              color: "white",
              fontSize: "3rem",
            }}
            onClick={() => setCreate(!create)}
          />
        </>
      )}
    </Box>
  );
};

export default DashJobs;
